<div class="row">
  <div class="col-sm-6 paddingZero">
    <!--   angular 13 upgrade <kendo-textbox-container>
    <input kendoTextBox placeholder="Search" (input)="onChangeFilter($event.target.value)" />
  </kendo-textbox-container>-->
    <kendo-formfield>
      <input kendoTextBox placeholder="Search" (input)="onChangeFilter($event.target.value)" />
      </kendo-formfield>
  </div>
</div>
<br />
<div class="panelbar-wrapper">
  <div class="row">
    <div class="col-sm-12 paddingZero">
      <kendo-panelbar [items]="faqItems">
        <ng-template kendoPanelBarItemTemplate let-dataItem>
          <div class="custom-template">
            <ul>
              <li *ngFor="let content of dataItem.content">{{content}}</li>
            </ul>
          </div>
        </ng-template>
      </kendo-panelbar>
    </div>
    
  </div>
</div>
